export const EmojiBad = [
  { id: 1, emoji: <>🙁</>, value: "Very Poor" },
  { id: 2, emoji: <>😦</>, value: "Very Unsatisfied" },
  { id: 3, emoji: <>😤</>, value: "Extremely unlikely" },
  { id: 4, emoji: <>😞</>, value: "Disapointed" },
  { id: 5, emoji: <>😓</>, value: "Unsatisfied" },
];

export const EmojiGood = [
  { id: 1, emoji: <>😊</>, value: "Excellent" },
  { id: 2, emoji: <>😍</>, value: "Very Satisfied" },
  { id: 3, emoji: <>🥰</>, value: "Absolutely" },
  { id: 4, emoji: <>😄</>, value: "Very Good" },
  { id: 5, emoji: <>🤩</>, value: "Wonderful" },
];
